// Create a proper SVG data URI for the magnifying glass icon
// Using encodeURIComponent for proper encoding
const searchIconSvg = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="oklch(0.464 0 0)"><path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"/></svg>`
const searchIconDataUri = `data:image/svg+xml,${encodeURIComponent(searchIconSvg)}`

const getSearchIcon = () => {
  return searchIconDataUri
}

export default getSearchIcon
